import { Button, makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    button: {
        color: tokens.colorNeutralForeground1,
        width: '100%',
        justifyContent: 'flex-start',
        ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalL),
        ':hover': {
            color: tokens.colorNeutralForeground1
        },
    },
});

interface AppMenuButtonProps {
    onClick: () => void;
    label: string;
    title: string;
    icon: JSX.Element;
    disabled?: boolean;
}
const AppMenuButton: FC<AppMenuButtonProps> = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { onClick, label, title, icon, disabled } = props;
    return (
        <Button
            className={classes.button}
            title={t(title)}
            icon={icon}
            onClick={onClick}
            disabled={disabled}
            appearance='primary'>
            {t(label)}
        </Button>
    );
};

export default AppMenuButton;
